import * as React from 'react';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import HeaderNavigation from '../../headers/HeaderNavigation/HeaderNavigation';
import UserInfo from '../../headers/UserInfo/UserInfo';
import PageHeader from '../../headers/PageHeader/PageHeader';
import ProjectHeaderButton from '../project/ProjectHeader/ProjectHeaderButton';
import getBaseUrl from '../../../services/mini/getBaseUrl';
import makeUrl from '../../../services/mini/makeUrl';
import { IProject } from '../../../models/IProject';
import { IStore } from '../../../redux/initialState';
import { Environment } from '../../../const/environment';

type EmbedHeaderProps = {
    project: IProject,
    environment: Environment,
    userEmail: string
}

function EmbedHeader({ project, environment, userEmail }: EmbedHeaderProps) {
    const openDemoCb = useCallback(() => {
        const key = `${project.projectId}/${environment}`;
        const demoUrl = `${getBaseUrl()}/web/alan_example.html?key=${makeUrl(key)}&projectName=${makeUrl(project.name)}&projectOwner=${makeUrl(userEmail)}&backUrl=${window.location.href}`;
        const win = window.open(demoUrl, '_blank');
        win.focus();
    }, [environment, project.name, project.projectId, userEmail]);
    return <PageHeader
        leftPart={
            <React.Fragment>
                <HeaderNavigation projectName={project.name} className="big-header" />
            </React.Fragment>
        }
        rightPart={
            <React.Fragment>
                <ProjectHeaderButton
                    id="demoLinkTooltip"
                    tip="Playground"
                    tooltipClass="demo-link-tooltip"
                    className="small-square-btn demo-link"
                    onClick={openDemoCb}
                    iconClass="icon-alan-demo-playground" />
                <UserInfo />
            </React.Fragment>
        }
    />;
}

function mapStateToProps({ projectsInfo, user }: IStore, ownProps) {
    return {
        project: projectsInfo.currentProject,
        userEmail: user.email,
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmbedHeader);